import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-17bafc16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings-page__content-container" }
const _hoisted_2 = { class: "settings-page__header" }
const _hoisted_3 = { class: "settings-page__title" }
const _hoisted_4 = { class: "settings-page__field-label-wrapper" }
const _hoisted_5 = { class: "settings-page__field-label-wrapper" }

import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import {
  IonContent,
  IonInput,
  IonList,
  IonItem,
  IonLabel,
  IonPage,
  IonSegment,
  IonSegmentButton,
  IonText,
  IonToggle,
  useIonRouter,
} from '@ionic/vue';
import { useI18n } from 'vue-i18n';
import { useComputeWizardStore } from '@/store/computeWizard';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { Lang } from '@/enums/Lang';
import { Unit } from '@/enums/Unit';
import { Icons } from '@/enums/Icons';
import { Platform } from '@/enums/Platform';
import { RouteName } from '@/enums/Router';
import useLangSettings from '@/composables/useLangSettings';
import useCalculationSettings from '@/composables/useCalculationSettings';
import BaseButton from '@/components/BaseButton';
import BaseIcon from '@/components/BaseIcon';


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsPage',
  setup(__props) {

const computeWizardStore = useComputeWizardStore();
const langSettings = useLangSettings();
const calculationSettings = useCalculationSettings();

const displayedClampingLevel = ref<number>(calculationSettings.clampingLevel.value);

const { t } = useI18n();

const langList = [
  {
    Iso: Lang.En.Iso,
    Label: Lang.En.ShortLabel,
  },
  {
    Iso: Lang.Fr.Iso,
    Label: Lang.Fr.ShortLabel,
  },
];

const router = useIonRouter();

const unitValue = computed(() => {
  return t('settings.fields.unit.label', { unit: calculationSettings.unit.value });
});

const onLangSegmentChange = (event: CustomEvent) => {
  langSettings.updateLangIso(event.detail.value);
};

const onClampingLevelChange = (event: CustomEvent) => {
  let value = parseInt(event.detail.value);

  if (!value || value < 1) {
    value = 1;
  }

  calculationSettings.clampingLevel.value = value > 100 ? 100 : value;
};

const onUnitToggleChange = (event: CustomEvent) => {
  calculationSettings.unit.value = event.detail.checked ? Unit.FootPoundForce : Unit.NewtonMeter;
};

const goBack = () => {
  computeWizardStore.updateFinalResult();
  if (Capacitor.getPlatform() === Platform.WEB) {
    router.push({ name: RouteName.HOME });
  } else {
    router.back();
  }
};

watch(calculationSettings.unit, () => {
  if (computeWizardStore.isValid) {
    computeWizardStore.updateFinalResult();
  }
});

onMounted(() => {
  if (Capacitor.getPlatform() === Platform.IOS) {
    StatusBar.setStyle({ style: Style.Dark });
  }
});

onUnmounted(() => {
  if (Capacitor.getPlatform() === Platform.IOS) {
    StatusBar.setStyle({ style: Style.Light });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), { class: "settings-page" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        class: "settings-page__content",
        color: "primary",
        forceOverscroll: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("header", _hoisted_2, [
              _createVNode(_unref(BaseButton), {
                class: "settings-page__close-button",
                color: "primary",
                onClick: goBack
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseIcon), {
                    class: "settings-page__close-button-icon",
                    icon: _unref(Icons).Cross
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_unref(IonText), { class: "settings-page__title-container" }, {
              default: _withCtx(() => [
                _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('settings.page.title')), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonSegment), {
              class: "settings-page__lang-segment",
              onIonChange: _cache[0] || (_cache[0] = ($event: any) => (onLangSegmentChange($event))),
              value: _unref(langSettings).currentLocale()
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(langList, (lang, index) => {
                  return _createVNode(_unref(IonSegmentButton), {
                    key: index,
                    class: _normalizeClass(`settings-page__lang-segment-button settings-page__lang-segment-button--${lang.Iso}`),
                    value: lang.Iso
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), {
                        class: _normalizeClass(`settings-page__lang-segment-label settings-page__lang-segment-label--${lang.Iso}`)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(lang.Label), 1)
                        ]),
                        _: 2
                      }, 1032, ["class"])
                    ]),
                    _: 2
                  }, 1032, ["class", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["value"]),
            _createVNode(_unref(IonList), { class: "settings-page__field-list" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonItem), {
                  class: "settings-page__field-item",
                  color: "primary",
                  lines: "full"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(IonLabel), { class: "settings-page__field-label" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('settings.fields.clamping_level.label')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonText), { class: "settings-page__field-hint" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('settings.fields.clamping_level.hint')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_unref(IonInput), {
                      class: "settings-page__field-input",
                      onIonChange: _cache[1] || (_cache[1] = ($event: any) => (onClampingLevelChange($event))),
                      value: displayedClampingLevel.value,
                      min: "1",
                      max: "100",
                      type: "number",
                      inputMode: "decimal",
                      pattern: "[0-9]*",
                      step: "1"
                    }, null, 8, ["value"]),
                    _createVNode(_unref(IonText), null, {
                      default: _withCtx(() => [
                        _createTextVNode("%")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), {
                  class: "settings-page__field-item",
                  color: "primary",
                  lines: "full"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_unref(IonLabel), { class: "settings-page__field-label" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(unitValue.value), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonText), { class: "settings-page__field-hint settings-page__field-hint--unit" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('settings.fields.unit.hint')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_unref(IonToggle), {
                      class: "settings-page__field-toggle",
                      onIonChange: _cache[2] || (_cache[2] = ($event: any) => (onUnitToggleChange($event))),
                      value: _unref(calculationSettings).unit.value,
                      checked: _unref(calculationSettings).unit.value === _unref(Unit).FootPoundForce
                    }, null, 8, ["value", "checked"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})